<app-header [breadcrumbs]="['Users', 'Add User']" mainHeading="Add User" [links]="['/users', '/add-user']" />

<form>
    <main class="add-new-shell">
        <cll-card class="add-new-card">
            <cll-card-header>
                <cll-icon cllCardIcon type="outlined">person</cll-icon>
                <cll-card-title>User basic details</cll-card-title>
            </cll-card-header>

            <div class="add-new-row-container">
                <div>
                    <cll-form-field label="Reference">
                        <input cllFormInput
                               [formControl]="userDetailsFormGroup.controls.reference"
                               type="text">
                        @if(userDetailsFormGroup.controls.reference.hasError('notUnique')) {
                            <cll-form-field-error>
                                Reference must be unique,
                                @if(userDetailsFormGroup.controls.reference.hasError('alternatives')) {
                                    try: {{
                                        userDetailsFormGroup.controls.reference.getError('alternatives')
                                            .join(', ')
                                    }}
                                }
                            </cll-form-field-error>
                        }
                    </cll-form-field>
                </div>
                <div class="grid-columns-3-small">
                    <div>
                        <cll-form-field label="Title" class="small-input">
                            <input cllFormInput
                                   [formControl]="personDetailsFormGroup.controls.title"
                                   type="text">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Given name" class="w-full">
                            <input cllFormInput
                                   [formControl]="personDetailsFormGroup.controls.given_name"
                                   type="text">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Family name" class="w-full">
                            <input cllFormInput
                                   [formControl]="personDetailsFormGroup.controls.family_name"
                                   type="text">
                        </cll-form-field>
                    </div>
                </div>
                <div>
                    <cll-form-field label="Middle names" class="w-full">
                        <input cllFormInput
                               [formControl]="personDetailsFormGroup.controls.middle_names"
                               type="text">
                    </cll-form-field>
                </div>
                <div class="grid-columns-2">
                    <div>
                        <cll-form-field label="Preferred name">
                            <input cllFormInput
                                   [formControl]="personDetailsFormGroup.controls.preferred_name"
                                   type="text">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Pronouns">
                            <input cllFormInput
                                   [formControl]="personDetailsFormGroup.controls.pronouns"
                                   type="text">
                        </cll-form-field>
                    </div>
                </div>
                <div class="grid-columns-2">
                    <div>
                        <cll-form-field label="Date of birth">
                            <input cllFormInput
                                   [formControl]="personDetailsFormGroup.controls.date_of_birth"
                                   type="date">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Birth sex" class="w-full">
                            <select cllFormInput
                                    [formControl]="personDetailsFormGroup.controls.birth_sex">
                                <option value=""></option>
                                <option value="m">Male</option>
                                <option value="f">Female</option>
                                <option value="o">Indeterminate</option>
                            </select>
                        </cll-form-field>
                    </div>
                </div>
                <div>
                    <cll-form-field label="Email address" class="w-full">
                        <input cllFormInput
                               [formControl]="userDetailsFormGroup.controls.email"
                               type="email">
                    </cll-form-field>
                </div>
                <div class="notification-checkboxes">
                    <span>Notification preferences (select where you want to receive system notifications)</span>
                    <cll-checkbox-collection direction="inline">
                        <cll-checkbox [formControl]="userDetailsFormGroup.controls.send_internal_messages"
                                      appearance="outlined" colour="secondary">CareBrokerage internal inbox
                        </cll-checkbox>
                        <cll-checkbox [formControl]="userDetailsFormGroup.controls.send_email_messages"
                                      appearance="outlined" colour="secondary">Email
                        </cll-checkbox>
                    </cll-checkbox-collection>
                </div>
            </div>
        </cll-card>
        @if (request.error(); as error) {
            <app-error-panel [error]="error" />
        }
        <cll-card>
            <div class="add-new-footer-buttons-container">
                <button cll-button (click)="cancel()">Cancel</button>
                <button cll-filled-button colour="secondary"
                        (click)="add()">
                    <cll-icon cllButtonIcon>check</cll-icon>
                    Create user
                </button>
            </div>
        </cll-card>
    </main>
</form>
